module.exports = {
  "container": {
    "overflow": "hidden"
  },
  "dof-skid": {
    "flexDirection": "row",
    "overflow": "hidden"
  },
  "itemWrap": {
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "stretch"
  },
  "swipe-action-right": {
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "stretch",
    "overflow": "hidden"
  },
  "swipeItem": {
    "justifyContent": "center",
    "alignItems": "center",
    "flex": 1,
    "position": "relative"
  },
  "mask": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0,
    "backgroundColor": "rgba(255,255,255,0)",
    "backgroundColor:active": "rgba(255,255,255,0.1)"
  },
  "swipeText": {
    "fontSize": "32",
    "color": "#ffffff",
    "textAlign": "center",
    "alignItems": "center",
    "lines": 2,
    "textOverflow": "ellipsis",
    "overflow": "hidden"
  },
  "cellBox": {
    "flex": 1
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-71f3f0fc!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-swipe-action/index.vue
// module id = 512
// module chunks = 0 1